// extracted by mini-css-extract-plugin
export default {"warning":"MessageSentContent_warning__hwjPr","container":"MessageSentContent_container__5uw9c"};